import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-900 text-slate-300 pt-20 pb-10 border-t border-white/10" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-37">
          {/* Company Info */}
          <div className="space-y-6" data-id="element-38">
            <Link to="/" className="flex items-center" data-id="element-39">
              <img src="https://cdn.magicpatterns.com/uploads/6U5SEn9XUuzRMnBoy5A9Hs/Invigo_Logo.png" alt="InvigoTech" className="h-10 w-auto object-contain brightness-0 invert" data-id="element-40" />
            </Link>
            <p className="text-sm leading-relaxed" data-id="element-41">
              Powering digital transformation across Africa. We deliver premium
              ICT infrastructure, systems integration, and managed services for
              enterprises and governments.
            </p>
            <div className="flex gap-4" data-id="element-42">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-43">
                <Linkedin className="w-5 h-5" data-id="element-44" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-45">
                <Twitter className="w-5 h-5" data-id="element-46" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-47">
                <Facebook className="w-5 h-5" data-id="element-48" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-tech-blue hover:text-white transition-colors" data-id="element-49">
                <Instagram className="w-5 h-5" data-id="element-50" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-51">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-52">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-53">
              <li data-id="element-54">
                <Link to="/about" className="hover:text-tech-green transition-colors" data-id="element-55">
                  About Us
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-57">
                  Our Services
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/projects" className="hover:text-tech-green transition-colors" data-id="element-59">
                  Case Studies
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/industries" className="hover:text-tech-green transition-colors" data-id="element-61">
                  Industries
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/insights" className="hover:text-tech-green transition-colors" data-id="element-63">
                  Insights & News
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-64">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-65">
              Our Services
            </h3>
            <ul className="space-y-4" data-id="element-66">
              <li data-id="element-67">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-68">
                  ICT Infrastructure
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-70">
                  Systems Integration
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-72">
                  Managed IT Services
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-74">
                  Business Process Mgmt
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/services" className="hover:text-tech-green transition-colors" data-id="element-76">
                  Digital Inclusion
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-77">
            <h3 className="text-white font-semibold text-lg mb-6" data-id="element-78">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-79">
              <li className="flex items-start gap-3" data-id="element-80">
                <MapPin className="w-5 h-5 text-tech-green shrink-0 mt-1" data-id="element-81" />
                <span data-id="element-82">Audu Ogbeh Street, Jabi, Abuja, Nigeria</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-83">
                <Phone className="w-5 h-5 text-tech-green shrink-0" data-id="element-84" />
                <span data-id="element-85">0700-INVIGO</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-86">
                <Mail className="w-5 h-5 text-tech-green shrink-0" data-id="element-87" />
                <span data-id="element-88">info@invigoco.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm" data-id="element-89">
          <div className="flex flex-col md:flex-row items-center gap-4" data-id="element-90">
            <p data-id="element-91">&copy; {currentYear} Invigo Technology. All rights reserved.</p>
            <span className="hidden md:inline text-white/20" data-id="element-92">|</span>
            <a href="https://www.invigoco.com" target="_blank" rel="noopener noreferrer" className="hover:text-tech-green transition-colors font-medium" data-id="element-93">
              www.invigoco.com
            </a>
          </div>
          <div className="flex gap-6" data-id="element-94">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-95">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-96">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}